export default function Smiley({ fillColor }) {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 35 35"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 4" opacity="0.9">
        <circle
          id="Ellipse 11"
          cx="17.5832"
          cy="17.8446"
          r="16.115"
          stroke={fillColor}
          strokeWidth="2.07936"
        />
        <path
          id="Ellipse 13"
          d="M28.8226 20.8023C28.2112 22.4299 27.3151 23.9089 26.1855 25.1546C25.0558 26.4003 23.7147 27.3885 22.2388 28.0627C20.7628 28.7369 19.1809 29.0839 17.5833 29.0839C15.9857 29.0839 14.4038 28.7369 12.9278 28.0627C11.4519 27.3885 10.1108 26.4003 8.98111 25.1546C7.85145 23.9089 6.95536 22.4299 6.34399 20.8023"
          stroke={fillColor}
          strokeWidth="2.07936"
          strokeLinecap="round"
        />
        <rect
          id="Rectangle 10"
          x="11.0763"
          y="8.9715"
          width="2.36617"
          height="7.09851"
          rx="1.18308"
          fill={fillColor}
        />
        <rect
          id="Rectangle 11"
          x="20.541"
          y="8.9715"
          width="2.36617"
          height="7.09851"
          rx="1.18308"
          fill={fillColor}
        />
      </g>
    </svg>
  );
}
